module.exports = __webpack_public_path__ + "img/icon-card-plus.2f5403f2.svg";